import React, { useState, useEffect } from "react";
import axios from "axios";
import "./assetTranferReport.css";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import Select from "react-select";

const AssetTranferAudit = () => {
  const [company, setCompany] = useState("");
  const [department, setDepartment] = useState("");
  const [category, setCategory] = useState("");
  const [type, setType] = useState("");
  const [selectedComputerComponent, setSelectedComputerComponent] = useState("");

  const [companies, setCompanies] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [allTypes, setAllTypes] = useState({});
  const [computerComponentOptions, setComputerComponentOptions] = useState([]);

  const [assetRegisterDetails, setAssetRegisterDetails] = useState([]);
  const [filteredAssets, setFilteredAssets] = useState([]);
  const [oldAssetDetails, setOldAssetDetails] = useState({});
  const[subComponent,setSubComponent]=useState("");

  useEffect(() => {
    fetchAssets();
  }, []);

  const fetchAssets = async () => {
    try {
      const response = await axios.get(
        "/api/AssetRegisterDetails/getAssetDetails"
      );

      const allAssets = response.data;

      // ✅ Transfer detection using transfer date
      const transferAssets = allAssets.filter(
        (asset) => asset.assetTransferDate
      );

      setAssetRegisterDetails(transferAssets);
      setFilteredAssets(transferAssets);

      // ================= FETCH HISTORY =================
      const oldDetailsMap = {};

      await Promise.all(
        transferAssets.map(async (asset) => {
          const trackingId = asset.trackingId;
          const allHistory = [];
          const visited = new Set();

          try {
            const res = await axios.get(
              `/api/beforeTransfer/getBeforeTransferDetails/${trackingId}`
            );

            let currentData = Array.isArray(res.data)
              ? res.data[0]
              : res.data;

            while (
              currentData &&
              currentData.trackingId &&
              !visited.has(currentData.trackingId)
            ) {
              visited.add(currentData.trackingId);
              allHistory.push(currentData);

              try {
                const moreRes = await axios.get(
                  `/api/beforeTransfer/getBeforeTransferAllDetails/${currentData.trackingId}`
                );

                const moreData = moreRes.data;

                if (Array.isArray(moreData) && moreData.length > 0) {
                  currentData = moreData[0];
                } else if (moreData && typeof moreData === "object") {
                  currentData = moreData;
                } else {
                  break;
                }
              } catch {
                break;
              }
            }

            oldDetailsMap[trackingId] = allHistory;
          } catch (err) {
            console.error("History fetch error:", err);
          }
        })
      );

      setOldAssetDetails(oldDetailsMap);

      // ================= FILTER DROPDOWNS =================
      setCompanies([...new Set(transferAssets.map(a => a.company))]);
      setDepartments([...new Set(transferAssets.map(a => a.department))]);
      setCategories([...new Set(transferAssets.map(a => a.category))]);
      setComputerComponentOptions(
        [...new Set(transferAssets.map(a => a.subComponent))].filter(Boolean)
      );

      const groupedTypes = transferAssets.reduce((acc, asset) => {
        if (!acc[asset.category]) acc[asset.category] = new Set();
        acc[asset.category].add(asset.type);
        return acc;
      }, {});
      setAllTypes(groupedTypes);

    } catch (error) {
      console.error("Error fetching asset details:", error);
    }
  };

  useEffect(() => {
    setTypes(category ? [...(allTypes[category] || [])] : []);
    setType("");
  }, [category]);

  useEffect(() => {
    filterAssets();
  }, [company, department, category, type, subComponent]);

  const filterAssets = () => {
    let filtered = [...assetRegisterDetails];

    if (company) filtered = filtered.filter(a => a.company === company);
    if (department) filtered = filtered.filter(a => a.department === department);
    if (category) filtered = filtered.filter(a => a.category === category);
    if (type) filtered = filtered.filter(a => a.type === type);
    if (subComponent)
      filtered = filtered.filter(
        a => a.subComponent === subComponent
      );

    setFilteredAssets(filtered);
  };

  const downloadExcel = () => {
  if (!filteredAssets.length) return alert("No data available.");

  const wb = XLSX.utils.book_new();

  // Header row
  const ws_data = [[
    "Label","Registered Name","Company","Department","Category","Type",
    "Sub Components","Asset Name","EPF No & Recipient Name","Model",
    "Register Date","Transfer Date","Serial","Tracking ID","Price",
    "Asset Image","Invoice Image","Warranty","Supplier Name","Invoice Number","Purchase Date"
  ]];

  filteredAssets.forEach(asset => {
    const history = oldAssetDetails[asset.trackingId] || [];

    // Transferred row
    ws_data.push([
      "Transferred",
      asset.name,
      asset.company,
      asset.department,
      asset.category,
      asset.type,
      asset.subComponent || "-",
      asset.assetName,
      asset.assetUserName,
      asset.assetModel,
      asset.assetUpdateDate,
      asset.assetTransferDate,
      asset.serialNumber,
      asset.trackingId,
      asset.assetprice,
      asset.assetImageURL || "-",
      asset.invoiceFileURL || "-",
      asset.warranty || "-",
      asset.supplierName || "-",
      asset.invoiceDetails || "-",
      asset.purchaseDate || "-"
    ]);

    // Old rows
    history.forEach((old, i) => {
      ws_data.push([
        `Old ${i+1}`,
        old?.name || "-",
        old?.company || "-",
        old?.department || "-",
        old?.category || "-",
        old?.type || "-",
        old?.subComponent || "-",
        old?.assetName || "-",
        old?.assetUserName || "-",
        old?.assetModel || "-",
        old?.assetUpdateDate || "-",
        old?.assetTransferDate || "-",
        old?.serialNumber || "-",
        old?.trackingId || "-",
        old?.assetprice || "-",
        old?.assetImageURL || "-",
        old?.invoiceFileURL || "-",
        old?.warranty || "-",
        old?.supplierName || "-",
        old?.invoiceDetails || "-",
        old?.purchaseDate || "-"
      ]);
    });
  });

  // Convert array to sheet
  const ws = XLSX.utils.aoa_to_sheet(ws_data);

  // Make hyperlinks for Asset Image and Invoice
  const range = XLSX.utils.decode_range(ws['!ref']);
  for (let R = 1; R <= range.e.r; ++R) {
    // Asset Image URL (column 16 = P)
    const assetImageCell = ws[XLSX.utils.encode_cell({ r: R, c: 15 })];
    if (assetImageCell?.v && assetImageCell.v !== "-") {
      assetImageCell.l = { Target: assetImageCell.v, Tooltip: "View Asset Image" };
    }

    // Invoice Image URL (column 17 = Q)
    const invoiceCell = ws[XLSX.utils.encode_cell({ r: R, c: 16 })];
    if (invoiceCell?.v && invoiceCell.v !== "-") {
      invoiceCell.l = { Target: invoiceCell.v, Tooltip: "View Invoice" };
    }
  }

  XLSX.utils.book_append_sheet(wb, ws, "Transfer Report");
  XLSX.writeFile(wb, "Transfer_Report.xlsx");
};


  const toOptions = arr => arr.map(v => ({ value: v, label: v }));

  return (
    <div>
      <h1 className="assethead" style={{ marginTop: "20px" }}>
        Download Transfer Report
      </h1>

      <p>
        <Link to="/AuditDashBoard">Dashboard</Link> /{" "}
        <Link to="/AssetTranfer">Report Transfer Details</Link>
      </p>

      <div className="filters">
        <Select
          placeholder="Select Company"
          options={toOptions(companies)}
          value={company ? { value: company, label: company } : null}
          onChange={sel => setCompany(sel?.value || "")}
          isClearable
        />

        <Select
          placeholder="Select Department"
          options={toOptions(departments)}
          value={department ? { value: department, label: department } : null}
          onChange={sel => setDepartment(sel?.value || "")}
          isClearable
        />

        <Select
          placeholder="Select Category"
          options={toOptions(categories)}
          value={category ? { value: category, label: category } : null}
          onChange={sel => setCategory(sel?.value || "")}
          isClearable
        />

        {category && (
          <Select
            placeholder="Select Type"
            options={toOptions(types)}
            value={type ? { value: type, label: type } : null}
            onChange={sel => setType(sel?.value || "")}
            isClearable
          />
        )}

          {type === "Desktop Computers" && (
                  <Select
                    placeholder="Select Component"
                    options={toOptions(computerComponentOptions)}
                    value={
                      subComponent
                        ? { value: subComponent, label: subComponent }
                        : null
                    }
                    onChange={sel => setSubComponent(sel?.value || "")}
                    isClearable
                  />
                )}
      </div>

      <div className="download-container">
        <button onClick={downloadExcel} className="download-btn1">
          Download Report
        </button>
      </div>

      {filteredAssets.length > 0 ? (
        <table className="asset-table">
          <thead>
            <tr>
              <th>Label</th>
              <th>Registered Name</th>
              <th>Company</th>
              <th>Department</th>
              <th>Category</th>
              <th>Type</th>
              <th>Sub Components</th>
              <th>Asset Name</th>
              <th>EPF No & Recipient Name</th>
              <th>Model</th>
              <th>Register Date</th>
              <th>Transfer Date</th>
              <th>Serial</th>
              <th>Tracking ID</th>
              <th>Price</th>
              
              <th>Asset Image</th>
              <th>Invoice Image</th>
              <th>Warranty</th>
              <th>Supplier Name</th>
              <th>Invoice Number</th>
              <th>Purchase Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredAssets.map((asset, index) => {
              const history = oldAssetDetails[asset.trackingId] || [];
              return (
                <React.Fragment key={index}>
                  <tr>
                    <td className="transfer">Transferred</td>
                    <td>{asset.name}</td>
                    <td>{asset.company}</td>
                    <td>{asset.department}</td>
                    <td>{asset.category}</td>
                    <td>{asset.type}</td>
                     <td>{asset.subComponent || "-"}</td>
                    <td>{asset.assetName}</td>
                    <td>{asset.assetUserName}</td>
                    <td>{asset.assetModel}</td>
                    <td>{asset.assetUpdateDate}</td>
                    <td>{asset.assetTransferDate}</td>
                    <td>{asset.serialNumber}</td>
                    <td>{asset.trackingId}</td>
                    <td>{asset.assetprice}</td>
                    <td>
                      {asset.assetImageURL ? (
                        <a
                          href={asset.assetImageURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Image
                        </a>
                      ) : (
                        "No Image"
                      )}
                    </td>

                    <td>
                      {asset.invoiceFileURL ? (
                        <a
                          href={asset.invoiceFileURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Invoice
                        </a>
                      ) : (
                        "No Invoice"
                      )}
                    </td>
                    <td>{asset.warranty || "-"}</td>
                    <td>{asset.supplierName || "-"}</td>
                    <td>{asset.invoiceDetails || "-"}</td>
                    <td>{asset.purchaseDate || "-"}</td>
                  </tr>

                  {history.map((old, i) => (
                    <tr key={`old-${index}-${i}`}>
                      <td className="old">Old {i+1}</td>
                      <td>{old?.name || "-"}</td>
                      <td>{old?.company || "-"}</td>
                      <td>{old?.department || "-"}</td>
                      <td>{old?.category || "-"}</td>
                      <td>{old?.type || "-"}</td>
                      <td>{old?.subComponent || "-"}</td>
                      <td>{old?.assetName || "-"}</td>
                      <td>{old?.assetUserName || "-"}</td>
                      <td>{old?.assetModel || "-"}</td>
                      <td>{old?.assetUpdateDate || "-"}</td>
                      <td>{old?.assetTransferDate || "-"}</td>
                      <td>{old?.serialNumber || "-"}</td>
                      <td>{old?.trackingId || "-"}</td>
                      <td>{old?.assetprice || "-"}</td>
                       <td>
                      {old?.assetImageURL ? (
                        <a
                          href={old?.assetImageURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Image
                        </a>
                      ) : (
                        "No Image"
                      )}
                    </td>

                    <td>
                      {old?.invoiceFileURL ? (
                        <a
                          href={old?.invoiceFileURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Invoice
                        </a>
                      ) : (
                        "No Invoice"
                      )}
                    </td>
                    <td>{old?.warranty || "-"}</td>
                    <td>{old?.supplierName || "-"}</td>
                    <td>{old?.invoiceDetails || "-"}</td>
                    <td>{old?.purchaseDate || "-"}</td>
                      
                    </tr>
                  ))}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      ) : (
        <p>No matching assets found.</p>
      )}
    </div>
  );
};

export default AssetTranferAudit;
